import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileCacheService {
  _debug=false;
	_promises = new Map<string,Promise<any>>();
  _files = new Map<string,any>();
  _caching=false;
  debug(msg:string):void{
    if(this._debug){
      console.log("FileCacheService: "+msg);
    }
  }
  constructor(private http: HttpClient) {
    
  }

  has( url : string ) :boolean{
    return this.hasFile(url);
  }

  hasFile( url : string ) : boolean{
  	return this._promises.has(url);
  }
  getBaseUrl(){
    return window.location.pathname;
  }
  getFile( _url : string ): Promise<any>{
    let url = _url;
    
    if(url.startsWith('/')){
      //console.log("replacing url.");
      url = this.getBaseUrl()+(url.replace('/',''));
    }

    if(this._promises.has(url)){
    	return this._promises.get(url);
   	}else{
       if(this._caching){

         if(localStorage.getItem('angular.xhr:'+url)){
           return new Promise( (resolve,reject)=>{
             this.debug("Returning from cache "+url);    
             resolve(JSON.parse(localStorage.getItem('ng.xhr:'+url)));
           });
         }
       }
   }
    
    let promise = this.http.get(url).toPromise();
    this._promises.set(url,promise);
    promise.then(
      (data)=>{
        if(this._caching){
          this.debug("Adding to cache "+url);    
          localStorage.setItem('ng.xhr:'+url,JSON.stringify(data));
        }
        this._files.set(url,data);
      }
    );
    return promise;
  }
}
